"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    isHaveChild: {
      //如果没有 表示最后一级
      type: Boolean,
      default: false
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
        icon = _context$props.icon,
        title = _context$props.title,
        isHaveChild = _context$props.isHaveChild;
    var vnodes = [];
    if (isHaveChild || title == '首页') vnodes.push(h("svg-icon", {
      "attrs": {
        "icon-class": icon
      }
    }));

    if (title) {
      vnodes.push(h("span", {
        "slot": 'title'
      }, [title]));
    }

    return vnodes;
  }
};
exports.default = _default;